import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetInsurance,
	adminGetAllInsurances,
	resetFocusInsurance,
	initNewInsurance,
	adminPatchInsurance,
	adminPostInsurance,
	adminDeleteInsurance,
} from "services/insurance";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Insurances/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	name: Yup.string().required("Champ requis"),
	isPromoted: Yup.boolean().required("Champ requis"),
});

class InsurancesAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusInsurance();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllInsurances();
	};

	focusOnElement = (elt) => {
		this.props.adminGetInsurance(elt);
	};

	onAddClick = () => {
		this.props.initNewInsurance();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostInsurance(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchInsurance(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteInsurance(this.props.insurances.focus.data);
	};

	render() {
		const { insurances } = this.props;
		const { focus, list } = insurances;
		const insurance = focus.data;
		const newInsurance = insurance !== null && insurance.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={insurances.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="MUTUELLES"
					addButtonText="Nouvelle mutuelle"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField={false}
					focusedEltId={insurance}
				/>

				<ElementFocus element={focus} list={list} entity="Mutuelles" icon="info">
					{insurance !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: insurance.id,
								name: insurance.name || "",
								isPromoted: insurance.isPromoted || false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusInsurance}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newInsurance ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newInsurance && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		insurances: state.admin.insurances,
	};
};

const mapDispatchToProps = {
	adminGetAllInsurances,
	adminGetInsurance,
	adminPatchInsurance,
	adminDeleteInsurance,
	resetFocusInsurance,
	adminPostInsurance,
	initNewInsurance,
};

export default connect(mapStateToProps, mapDispatchToProps)(InsurancesAdmin);
